export const Header = () => {
  return (
    <div className={"header"}>
      <div className={"nav"}>
        <div>
          <a className={"navbar-brand cursor-pointer"} href="/">
            <img
              alt={"beralink"}
              src={"/images/logo.png"}
              data-at2x="/images/logo@2x.png"
            />
          </a>
        </div>
      </div>
    </div>
  );
};
